<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="fecharAlertSucesso($event)"></app-success-generico>
@if (alertAprovarRotaInteligente) {
  <app-alert-refazer-rota [dadosRoteirizacao]="detalheRoteirizacao" (alertRefazerRotaFechou)="eventoAlertRefazerRota($event)"></app-alert-refazer-rota>
}
@if (alertPergunta) {
  <app-alert-pergunta (alertPerguntaFechou)="eventoAlertPergunta($event)"></app-alert-pergunta>
}
<app-alert-erro-customizado [alertErro]="alertError" [alertErroBotao]="'FECHAR'" [alertErroTitulo]="tituloMensagemErro" [alertErroMensagem]="mensagemErro" (alertErroFechou)="fecharAlertError($event)"></app-alert-erro-customizado>

<!-- ALERT PARA ADICIONAR DEPARTAMENTO -->
<app-alert-novo-departamento [alertIncluirDepartamento]="alertIncluirDepartamento"
  (alertIncluirDepartamentoFechou)="eventoAlertIncluirDepartamento($event)">
</app-alert-novo-departamento>
<!-- ALERT PARA ADICIONAR CARGO -->
<app-alert-novo-cargo [alertIncluirCargo]="alertIncluirCargo"
  (alertIncluirCargoFechou)="eventoAlertIncluirCargo($event)">
</app-alert-novo-cargo>
<!-- ALERT PARA ADICIONAR ENDEREÇO -->
<app-alert-novo-endereco [alertIncluirEndereco]="alertIncluirEndereco"
  (alertIncluirEnderecoFechou)="eventoAlertIncluirEndereco($event)">
</app-alert-novo-endereco>

<div class="container py-4">
  @if (dadosUsuario || !edicaoUsuario) {
    <div class="row">
      <div [ngClass]="{ 'col-12': abaSelecionada != 3, 'col-12 col-lg-8': abaSelecionada == 3}">
        <div class="card">
          <app-breadcrumb></app-breadcrumb>
          <h1 class="titulo">Dados do Usuário
            <button
              class="btn-icon"
              (click)="goBackPage()"
              (keydown)="goBackPage()"
              aria-label="Voltar página">
              <i class="fa fa-arrow-left botao-setinha-voltar" aria-hidden="true"></i>
            </button>
          </h1>
          <p class="paragrafo mb-4">Cadastro de usuários que utilizam benefícios na empresa</p>
          <div class="w-100 d-flex">
            <button
              class="me-5 btn p-0 border-0 bg-transparent"
              [ngClass]="{'ativo': abaSelecionada == 1}"
              (click)="alterarAba(1)"
              (keydown)="alterarAba(1)">
              <span class="numero-aba">1</span>
              <span class="texto-aba">Dados Pessoais</span>
            </button>
            @if (formularioAba1.valid) {
              <button
                class="me-5 btn p-0 border-0 bg-transparent"
                [ngClass]="{'ativo': abaSelecionada == 2}"
                (click)="alterarAba(2)"
                (keydown)="alterarAba(2)"
                >
                <span class="numero-aba">2</span>
                <span class="texto-aba">Dados Complementares</span>
              </button>
            }
            @if (!formularioAba1.valid) {
              <button
                class="me-5 btn p-0 border-0 bg-transparent"
                data-bs-toggle="tooltip"
                data-placement="top"
                title="Preencha os dados obrigatórios da primeira aba."
                disabled
                >
                <span class="numero-aba">2</span>
                <span class="texto-aba">Dados Complementares</span>
              </button>
            }
            @if (idUsuario) {
              <button
                class="me-5 btn p-0 border-0 bg-transparent"
                [ngClass]="{'ativo': abaSelecionada == 3}"
                (click)="alterarAba(3)"
                (keydown)="alterarAba(3)"
                >
                <span class="numero-aba">3</span>
                <span class="texto-aba">Benefício</span>
              </button>
            }
            @if (!idUsuario) {
              <button
                class="me-5 btn p-0 border-0 bg-transparent"
                data-bs-toggle="tooltip"
                data-placement="top"
                title="Salve os dados da aba 1 e 2 primeiro"
                disabled
                >
                <span class="numero-aba">3</span>
                <span class="texto-aba">Benefício</span>
              </button>
            }
          </div>
          <!-- ABAS -->
          <!-- ABA DADOS PESSOAIS - 1 -->
          @if (abaSelecionada == 1) {
            <div class="w-100 mt-4">
              <form [formGroup]="formularioAba1" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                  <div class="col-12 col-lg-2">
                    @if (!fotoUsuario && !idUsuario) {
                      <img src="/assets/img/upload-foto.PNG" class="mt-4 disabled" width="140px" alt="Upload">
                      } @if (!idUsuario) {
                      <br>
                      }
                      @if (!fotoUsuario && idUsuario) {
                        <button
                          class="btn p-0 border-0 bg-transparent"
                          (click)="abrirAlertIncluirFoto()"
                          (keydown)="abrirAlertIncluirFoto()"
                          aria-label="Upload de foto">
                          <img src="/assets/img/upload-foto.PNG" alt="Upload" class="mt-4" width="140px">
                        </button>
                      }
                      @if (idUsuario) {
                        <br>
                        }
                        @if (fotoUsuario) {
                          <img [src]="fotoUsuario" class="mt-4" width="140px" alt="Usuario" [ngClass]="{'disabled': idUsuario == 0}">
                          } @if (fotoUsuario) {
                          <br>
                          }
                          <button class="botao-upload ms-3" (click)="abrirAlertIncluirFoto()" [ngClass]="{'disabled': idUsuario == 0}" [disabled]="idUsuario == 0" data-bs-toggle="tooltip" data-placement="top" title="Primeiro salve os dados do usuario">Incluir foto</button>
                          @if (idUsuario == 0 && statusApiFoto === undefined) {
                            <p class="legenda mt-2">Primeiro salve os dados do usuario na aba 2 para adicionar uma foto.</p>
                          }
                          @if (idUsuario != 0 && statusApiFoto === undefined && edicaoUsuario === false) {
                            <p class="legenda mt-2" >Pronto, agora você pode adicionar uma foto.</p>
                          }
                          @if (statusApiFoto === true) {
                            <p class="h6 c-primary mt-2 ms-2">Foto salva com sucesso ✓</p>
                          }
                        </div>
                        <div class="col-12 col-lg-10">
                          <div class="row">
                            <div class="col-12 col-md-6 col-lg-4 mb-4">
                              <div class="mb-3">
                                <label class="label-menor" for="matricula">MATRÍCULA</label>
                                <input type="text" id="matricula" class="form-control" formControlName="matricula" (focus)="habilitaBotaoSalvar = true" placeholder="Número matrícula">
                              </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mb-4">
                              <div class="mb-3">
                                <label class="label-menor" for="nomeCompleto">NOME COMPLETO <span class="c-danger">*</span></label>
                                <input type="text" id="nomeCompleto" class="form-control" formControlName="nomeCompleto" [ngClass]="{ 'is-invalid': !formularioAba1.get('nomeCompleto').valid && formularioAba1.get('nomeCompleto').touched }" (focus)="habilitaBotaoSalvar = true" placeholder="Nome completo">
                              </div>
                              @if (!formularioAba1.get('nomeCompleto').valid) {
                                <p class="legenda-erro">Caracteres especiais não são suportados pelo sistema.</p>
                              }
                            </div>
                            <div class="col-8 col-md-6 col-lg-4 mb-4">
                              <label class="label-menor" for="dataNascimento">DATA NASCIMENTO <span class="c-danger">*</span></label>
                              <input class="form-control" id="dataNascimento" [ngClass]="{ 'is-invalid': dataNascimentoInvalida}" dateMask [matDatepicker]="picker" formControlName="dataNascimento" placeholder='dd/mm/aaaa'
                                (dateChange)="verificaIdade()">
                              <mat-datepicker-toggle matSuffix [for]="picker" class="datepicker-custom-float"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                              @if (dataNascimentoInvalida) {
                                <p class="legenda-erro mt-2">{{dataNascimentoInvalida}}</p>
                              }
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mb-4">
                              <div class="mb-3">
                                <label class="label-menor" for="cpf">CPF <span class="c-danger">*</span></label>
                                <input type="text" id="cpf" class="form-control" formControlName="cpf" mask="000.000.000-00" [dropSpecialCharacters]="true" [ngClass]="{ 'is-invalid': !formularioAba1.get('cpf').valid && formularioAba1.get('cpf').touched }" (focus)="habilitaBotaoSalvar = true" placeholder="Número do CPF">
                              </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mb-4">
                              <div class="mb-3">
                                <label class="label-menor" for="rg">RG</label>
                                <input type="text" id="rg" class="form-control" formControlName="rg" (focus)="habilitaBotaoSalvar = true" placeholder="Número do RG">
                              </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mb-4">
                              @if (estadosUf) {
                                <div class="mb-3">
                                  <label class="label-menor" for="uf">UF</label>
                                  <app-select
                                    [form]="formularioAba1"
                                    name="uf"
                                    [options]="estadosUf"
                                    id="uf"
                                    optionValue="codigoEstado"
                                    defaultDescription="Selecione"
                                    optionText="estado"
                                    (change)="habilitaBotaoSalvar = true">
                                  </app-select>
                                </div>
                              }
                              @if (estadosUf === null) {
                                <div>
                                  <div class="text-center">
                                    <output class="spinner-border c-primary">
                                      <span class="visually-hidden">Consultando endereços ...</span>
                                    </output>
                                  </div>
                                  <p class="legenda-spinner">Consultando endereços ...</p>
                                </div>
                              }
                              @if (estadosUf === false) {
                                <div><p class="legenda-erro">Erro na consulta de estados</p></div>
                              }
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mb-4">
                              <div class="mb-3">
                                <label class="label-menor" for="genero">GÊNERO <span class="c-danger">*</span></label>
                                <app-select
                                  [form]="formularioAba1"
                                  name="genero"
                                  id="genero"
                                  (change)="habilitaBotaoSalvar = true"
                        [options]="[
                                        { description : 'Selecione' ,
                                          value : ''} ,
                                          { description : 'Masculino' ,
                                          value : 'M'} ,
                                          { description : 'Feminino' ,
                                          value : 'F'}
                                        ]"
                                  optionValue="value"
                                  optionText="description">
                                </app-select>
                              </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mb-4">
                              <div class="mb-3">
                                <label class="label-menor" for="nomeMae">NOME DA MÃE</label>
                                <input type="text" class="form-control" id="nomeMae" formControlName="nomeMae" (focus)="habilitaBotaoSalvar = true" placeholder="Nome completo"
                                  [ngClass]="{ 'is-invalid': !formularioAba1.get('nomeMae').valid}">
                                @if (!formularioAba1.get('nomeMae').valid) {
                                  <p class="legenda-erro">Caracteres especiais não são suportados pelo sistema.</p>
                                }
                              </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4 mb-4">
                              <div class="mb-3">
                                <label class="label-menor" for="situacao">SITUAÇÃO <span class="c-danger">*</span></label>
                                <app-select
                                  [form]="formularioAba1"
                                  [ngClass]="{ 'is-invalid': !formularioAba1.get('situacao').valid && formularioAba1.get('situacao').touched }"
                                  name="situacao"
                                  id="situacao"
                        [options]="[
                                          { description : 'Ativo' ,
                                          value : 'S'} ,
                                          { description : 'Inativo' ,
                                          value : 'N'}
                                        ]"
                                  optionValue="value"
                                  optionText="description"
                                  (change)="habilitaBotaoSalvar = true">
                                </app-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row border-top pt-3">
                        <div class="col-12 col-md-6 col-lg-4 mb-4">
                          <div class="mb-3" style="position: relative;">
                            <label class="label-menor" for="salario">SALÁRIO</label>
                            <input
                              type="text"
                              class="form-control input-salario"
                              id="salario"
                              placeholder="Ex: 2.850,00"
                              mask="separator.2"
                              thousandSeparator="."
                              decimalMarker=","
                              formControlName="salario"
                              (focus)="habilitaBotaoSalvar = true">
                            <span class="label-salario">R$</span>
                          </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 mb-4">
                          <div class="mb-3">
                            <label class="label-menor" for="email">E-MAIL</label>
                            <input type="text" id="email" class="form-control" formControlName="email" (focus)="habilitaBotaoSalvar = true" placeholder="Preencha com e-mail">
                          </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 mb-4">
                          <div class="mb-3">
                            <label class="label-menor" for="celular">CELULAR</label>
                            <input type="text" id="celular" class="form-control" formControlName="celular" mask="(00) 00000-0000" [dropSpecialCharacters]="true" (focus)="habilitaBotaoSalvar = true" placeholder="(xx) xxxxx-xxxx">
                          </div>
                        </div>
                      </div>
                      <div class="bottom-content border-top pt-4">
                        <div class="col-12 col-md-6 col-lg mb-4">
                          <div class="mb-3">
                            <label class="label-menor" for="codBanco">COD. DO BANCO</label>
                            <input type="text" id="codBanco" class="form-control" mask="000" formControlName="codBanco" (focus)="habilitaBotaoSalvar = true" placeholder="Banco">
                          </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg mb-4">
                          <div class="mb-3">
                            <label class="label-menor" for="codAgencia">COD. AGÊNCIA</label>
                            <input type="text" id="codAgencia" class="form-control" mask="0000" formControlName="codAgencia" (focus)="habilitaBotaoSalvar = true" placeholder="Agência">
                          </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg mb-4">
                          <div class="mb-3">
                            <label class="label-menor" for="digAgencia">DIG. AGÊNCIA</label>
                            <input type="text" id="digAgencia" class="form-control"  mask="A" formControlName="digAgencia" (focus)="habilitaBotaoSalvar = true" placeholder="Digito">
                          </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg mb-4">
                          <div class="mb-3">
                            <label class="label-menor" for="ctaCorrente">CTA. CORRENTE</label>
                            <input type="text" id="ctaCorrente" class="form-control" mask="000000000000" formControlName="ctaCorrente" (focus)="habilitaBotaoSalvar = true" placeholder="Número">
                          </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg mb-4">
                          <div class="mb-3">
                            <label class="label-menor" for="digCC">DIG. CC</label>
                            <input type="text" id="digCC" class="form-control"mask="A" formControlName="digCC" (focus)="habilitaBotaoSalvar = true" placeholder="Dígito">
                          </div>
                        </div>
                        <div class="mt-4">
                          <i
                            class="fa fa-info-circle c-black fa-1x ms-3 mt-2 icone-dados"
                            aria-hidden="true"
                            [popover]="myPopoverDadosBancarios"
                            popoverTitle="Dados bancários"
                            popoverPlacement="top"
                            triggers="click"
                            [outsideClick]="true">
                          </i>
                          <ng-template #myPopoverDadosBancarios>
                            <span class="texto-tabela">
                              Utilize o banco para inserir dados bancários.
                            </span>
                          </ng-template>
                        </div>
                        @if (pixUsuarioHabilitado) {
                          <div class="input-chave-pix">
                            <div class="mb-3">
                              <label class="label-menor" for="chavePix">Chave PIX</label>
                              <input type="text" class="form-control" formControlName="chavePix" (focus)="habilitaBotaoSalvar = true"
                                (keyup)="validaChavePix($event)"
                                size="50" maxlength="80" placeholder="CPF, E-Mail ou Telefone"
                                [ngClass]="{ 'is-invalid': !formularioAba1.get('chavePix').valid}">
                              @if (tipoChave) {
                                <p [class]="colorChave" ]>{{ tipoChave }}</p>
                              }
                            </div>
                          </div>
                        }
                        @if (pixUsuarioHabilitado) {
                          <div class="mt-4">
                            <i
                              class="fa fa-info-circle c-black fa-1x ms-3 mt-2 icone-dados"
                              aria-hidden="true"
                              [popover]="myPopoverChavePix"
                              popoverTitle="Chaves Pix"
                              popoverPlacement="top"
                              triggers="click"
                              [outsideClick]="true">
                            </i>
                            <ng-template #myPopoverChavePix>
                              <span class="texto-tabela">
                                São permitidos os seguintes tipos de chave PIX:
                                <ul>
                                  <li><b>CPF:</b> 999.999.999-99</li>
                                  <li><b>E-Mail:</b> teste&#64;email.com.br</li>
                                  <li><b>Telefone:</b> (99) 99999-9999</li>
                                </ul>
                              </span>
                            </ng-template>
                            <span id="tipoChave" style="display: none">{{ tipoChave }}</span>
                          </div>
                        }
                      </div>
                    </form>
                    <div class="row border-top py-4 text-center">
                      <button class="botao-outline px-5 mx-auto" [routerLink]="['/usuario-beneficio']">FECHAR</button>
                      <button class="botao mx-auto px-5" [ngClass]="{ 'disabled': !formularioAba1.valid }" [disabled]="!formularioAba1.valid" data-bs-toggle="tooltip" data-placement="top" title="Preencha todos os campos obrigatórios para avançar." (click)="alterarAba(2)">PRÓXIMO</button>
                    </div>
                  </div>
                }
                <!-- ABA 2 - DEPARTAMENTO -->
                @if (abaSelecionada == 2) {
                  <div class="w-100 mt-4">
                    <form [formGroup]="formularioAba2" (keydown.enter)="$event.preventDefault()">
                      <div class="row">
                        <div class="col-6 col-lg-3 mb-4">
                          @if (departamentos) {
                            <div class="mb-3">
                              <label class="label-menor" for="">DEPARTAMENTO <span class="c-danger">*</span></label>
                              <app-select
                                [form]="formularioAba2"
                                name="departamento"
                                id="departamento"
                                [options]="departamentos"
                                optionValue="idDepartamento"
                                defaultDescription="Selecione"
                                optionText="descDepartamento"
                                [ngClass]="{ 'is-invalid': !formularioAba2.get('departamento').valid && formularioAba2.get('departamento').touched }"
                                (change)="habilitaBotaoSalvar = true">
                              </app-select>
                            </div>
                          }
                          @if (departamentos === null) {
                            <div>
                              <div class="text-center">
                                <output class="spinner-border c-primary">
                                  <span class="visually-hidden">Consultando departamentos ...</span>
                                </output>
                              </div>
                              <p class="legenda-spinner">Consultando departamentos ...</p>
                            </div>
                          }
                          @if (departamentos === false) {
                            <div><p class="legenda-erro">Erro na consulta de departamentos</p></div>
                          }
                        </div>
                        <div class="col-6 col-lg-3 mb-4 mt-2">
                          <br>
                            <button class="botao-outline" (click)="abrirAlertIncluirDepartamento()">+ DEPARTAMENTO</button>
                            <i
                              class="fa fa-info-circle c-black fa-1x ms-3 mt-2 icone-dados"
                              aria-hidden="true"
                              [popover]="popoverDepartamento"
                              popoverTitle="Departamento"
                              popoverPlacement="top"
                              triggers="click"
                              [outsideClick]="true">
                            </i>
                            <ng-template #popoverDepartamento>
                              <span class="texto-tabela">
                                Clique aqui para cadastrar um novo departamento.
                              </span>
                            </ng-template>
                          </div>
                          <div class="col-6 col-lg-3 mb-4">
                            @if (cargos) {
                              <div class="mb-3">
                                <label class="label-menor" for="cargo">CARGO <span class="c-danger">*</span></label>
                                <app-select
                                  [form]="formularioAba2"
                                  name="cargo"
                                  id="cargo"
                                  [options]="cargos"
                                  optionValue="idCargo"
                                  defaultDescription="Selecione"
                                  optionText="descCargoEmpresa"
                                  [ngClass]="{ 'is-invalid': !formularioAba2.get('cargo').valid && formularioAba2.get('cargo').touched }" (change)="habilitaBotaoSalvar = true">
                                </app-select>
                              </div>
                            }
                            @if (cargos === null) {
                              <div>
                                <div class="text-center">
                                  <output class="spinner-border c-primary">
                                    <span class="visually-hidden">Consultando cargos ...</span>
                                  </output>
                                </div>
                                <p class="legenda-spinner">Consultando cargos ...</p>
                              </div>
                            }
                            @if (cargos === false) {
                              <div><p class="legenda-erro">Erro na consulta de cargos</p></div>
                            }
                          </div>
                          <div class="col-6 col-lg-3 mb-4 mt-2">
                            <br>
                              <button class="botao-outline" (click)="abrirAlertIncluirCargo()">+ CARGO</button>
                              <i
                                class="fa fa-info-circle c-black fa-1x ms-3 mt-2 icone-dados"
                                aria-hidden="true"
                                [popover]="popoverCargo"
                                popoverTitle="Cargo"
                                popoverPlacement="top"
                                triggers="click"
                                [outsideClick]="true">
                              </i>
                              <ng-template #popoverCargo>
                                <span class="texto-tabela">
                                  Clique aqui para cadastrar um novo cargo.
                                </span>
                              </ng-template>
                            </div>
                          </div>
                          <div class="row mt-3">
                            <div class="col-8 col-md-9 mb-4">
                              @if (enderecos) {
                                <div class="mb-3">
                                  <label class="label-menor" for="localEntrega">LOCAL PRA ENTREGA <span class="c-danger">*</span></label>
                                  <app-select
                                    [form]="formularioAba2"
                                    name="localEntrega"
                                    id="localEntrega"
                                    [options]="enderecosOptions"
                                    (change)="habilitaBotaoSalvar = true"
                                    defaultDescription="Selecione"
                                    [ngClass]="{ 'is-invalid': !formularioAba2.get('localEntrega').valid && formularioAba2.get('localEntrega').touched }"
                                    optionValue="value"
                                    optionText="description">
                                  </app-select>
                                </div>
                              }
                              @if (enderecos === null) {
                                <div>
                                  <div class="text-center">
                                    <output class="spinner-border c-primary">
                                      <span class="visually-hidden">Consultando endereços ...</span>
                                    </output>
                                  </div>
                                  <p class="legenda-spinner">Consultando endereços ...</p>
                                </div>
                              }
                              @if (enderecos === false) {
                                <div><p class="legenda-erro">Erro na consulta de endereços</p></div>
                              }
                            </div>
                            <div class="col-4 col-md-3 mb-4 mt-2">
                              <br>
                                <button class="botao-outline" (click)="abrirAlertIncluirEndereco()">+ ENDEREÇO</button>
                                <i
                                  class="fa fa-info-circle c-black fa-1x ms-3 mt-2 icone-dados"
                                  aria-hidden="true"
                                  [popover]="popoverLocalEntrega"
                                  popoverTitle="Local de entrega"
                                  popoverPlacement="top"
                                  triggers="click"
                                  [outsideClick]="true">
                                </i>
                                <ng-template #popoverLocalEntrega>
                                  <span class="texto-tabela">
                                    Seleciona o local para a entrega.
                                  </span>
                                </ng-template>
                              </div>
                            </div>
                            <div class="row border-top pt-4">
                              <div class="col-10 col-lg-3 col-xl-3">
                                <div class="mb-3">
                                  <label class="label" for="switchReplicarEndereco">REPLICAR ENDEREÇO?
                                    <i
                                      class="fa fa-info-circle c-black fa-1x ms-1 mt-2 icone-dados"
                                      aria-hidden="true"
                                      [popover]="popoverReplicarEndereco"
                                      popoverTitle="Replicar endereço local de trabalho"
                                      popoverPlacement="top"
                                      triggers="click"
                                      [outsideClick]="true">
                                    </i>
                                    <ng-template #popoverReplicarEndereco>
                                      <span class="texto-tabela">
                                        Clicando nessa opção o endereço de entrega será para o local de trabalho.
                                      </span>
                                    </ng-template>
                                  </label>
                                  <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input" id="switchReplicarEndereco" [ngClass]="{ 'disabled': !formularioAba2.value.localEntrega}" [disabled]="!formularioAba2.value.localEntrega" (change)="replicarEndereco($event.target)">
                                    <label class="form-check-label" for="switchReplicarEndereco">Sim</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 col-md-6 col-lg-3 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="cepTrabalho">CEP TRABALHO</label>
                                  <input type="text" id="cepTrabalho" class="form-control" formControlName="cepTrabalho" mask="00000-000" (blur)="consultarCep('cepTrabalho')" (focus)="habilitaBotaoSalvar = true" (keyup)="resetaCep()" placeholder="00000-000">
                                </div>
                              </div>
                              @if (consultaCepTrabalho === null || consultaCepTrabalho === false) {
                                <div class="col-12 mb-4">
                                  @if (consultaCepTrabalho === null) {
                                    <div>
                                      <div class="text-start">
                                        <output class="spinner-border c-primary">
                                          <span class="visually-hidden">Consultando CEP ...</span>
                                        </output>
                                      </div>
                                      <p class="legenda-spinner text-start">Consultando CEP ...</p>
                                    </div>
                                  }
                                  @if (consultaCepTrabalho === false) {
                                    <p class="legenda-erro">Erro na consulta. Verifique o CEP.</p>
                                  }
                                </div>
                              }
                              <div class="col-12 col-md-6 col-lg-4 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="logradouroTrabalho">LOGRADOURO TRABALHO</label>
                                  <input type="text" class="form-control" formControlName="logradouroTrabalho" (focus)="habilitaBotaoSalvar = true" placeholder="Digite o endereço" [readonly]="true" id="logradouroTrabalho">
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-2 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="numeroTrabalho">NÚMERO</label>
                                  <input type="text" id="numeroTrabalho" class="form-control" formControlName="numeroTrabalho" (focus)="habilitaBotaoSalvar = true" placeholder="Número">
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-3 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="complementoTrabalho">COMPLEMENTO</label>
                                  <input type="text" id="complementoTrabalho" class="form-control" formControlName="complementoTrabalho" (focus)="habilitaBotaoSalvar = true" placeholder="Ex: Rua sem saída">
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-3 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="bairroTrabalho">BAIRRO</label>
                                  <input type="text" itemid="bairroTrabalho" class="form-control" formControlName="bairroTrabalho" placeholder="Nome do bairro" (focus)="habilitaBotaoSalvar = true" [readonly]="true" id="bairroTrabalho">
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-4 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="cidadeTrabalho">CIDADE</label>
                                  <input type="text" class="form-control" formControlName="cidadeTrabalho" placeholder="Nome da cidade" (focus)="habilitaBotaoSalvar = true" [readonly]="true" id="cidadeTrabalho">
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-2 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="ufTrabalho">UF</label>
                                  <app-select
                                    [form]="formularioAba2"
                                    name="ufTrabalho"
                                    id="ufTrabalho"
                                    [disabled] = "true"
                                    [options]="estadosUf"
                                    optionValue="codigoEstado"
                                    defaultDescription="Selecione"
                                    optionText="estado"
                                    (change)="habilitaBotaoSalvar = true">
                                  </app-select>
                                </div>
                              </div>
                              <div class="d-none d-lg-block col-lg-3"></div>
                              <div class="col-12 col-md-6 col-lg-3 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="">CEP RESIDÊNCIA</label>
                                  <input type="text"  id="cepResidencia" class="form-control" formControlName="cepResidencia" mask="00000-000" (blur)="consultarCep('cepResidencia')" (focus)="habilitaBotaoSalvar = true" (keyup)="resetaCep()" placeholder="00000-000">
                                </div>
                              </div>
                              @if (consultaCepResidencia === null || consultaCepResidencia === false) {
                                <div class="col-12 mb-4">
                                  @if (consultaCepResidencia === null) {
                                    <div>
                                      <div class="text-start">
                                        <output class="spinner-border c-primary">
                                          <span class="visually-hidden">Consultando CEP ...</span>
                                        </output>
                                      </div>
                                      <p class="legenda-spinner text-start">Consultando CEP ...</p>
                                    </div>
                                  }
                                  @if (consultaCepResidencia === false) {
                                    <p class="legenda-erro">Erro na consulta. Verifique o CEP.</p>
                                  }
                                </div>
                              }
                              <div class="col-12 col-md-6 col-lg-4 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="logradouroResidencia">LOGRADOURO RESIDÊNCIA</label>
                                  <input type="text" class="form-control" formControlName="logradouroResidencia" (focus)="habilitaBotaoSalvar = true" placeholder="Digite o endereço" [readonly]="true" id="logradouroResidencia">
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-2 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="numeroResidencia">NÚMERO</label>
                                  <input type="text" id="numeroResidencia" class="form-control" formControlName="numeroResidencia" (focus)="habilitaBotaoSalvar = true" placeholder="Número">
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-3 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="complementoResidencia">COMPLEMENTO</label>
                                  <input type="text" id="complementoResidencia" class="form-control" formControlName="complementoResidencia" (focus)="habilitaBotaoSalvar = true" placeholder="Ex: Rua sem saída">
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-3 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="bairroResidencia">BAIRRO</label>
                                  <input type="text" class="form-control" formControlName="bairroResidencia" (focus)="habilitaBotaoSalvar = true" placeholder="Nome do bairro" [readonly]="true" id="bairroResidencia">
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-4 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="cidadeResidencia">CIDADE</label>
                                  <input type="text" class="form-control" formControlName="cidadeResidencia" (focus)="habilitaBotaoSalvar = true" placeholder="Nome da cidade" [readonly]="true" id="cidadeResidencia">
                                </div>
                              </div>
                              <div class="col-12 col-md-6 col-lg-2 mb-4">
                                <div class="mb-3">
                                  <label class="label-menor" for="ufResidencia">UF</label>
                                  <app-select
                                    [form]="formularioAba2"
                                    name="ufResidencia"
                                    id="ufResidencia"
                                    [disabled] = "true"
                                    [options]="estadosUf"
                                    optionValue="codigoEstado"
                                    defaultDescription="Selecione"
                                    optionText="estado"
                                    (change)="habilitaBotaoSalvar = true">
                                  </app-select>
                                </div>
                              </div>
                              <div class="d-none d-lg-block col-lg-3"></div>
                            </div>
                          </form>
                          <div class="row border-top py-4 text-center">
                            <button class="botao-outline mx-auto px-5" [routerLink]="['/usuario-beneficio']">FECHAR</button>
                            <button class="botao mx-auto px-5"  [ngClass]="{ 'disabled': !formularioAba2.valid }" [disabled]="!formularioAba2.valid" data-bs-toggle="tooltip" data-placement="top" title="Preencha todos os campos obrigatórios para salvar os dados." (click)="adicionarUsuario()" [disabled]="!habilitaBotaoSalvar" [ngClass]="{'disabled': !habilitaBotaoSalvar}">SALVAR</button>
                          </div>
                        </div>
                      }
                      <!-- ABA 3 - BENEFÍCIOS -->
                      @if (abaSelecionada == 3) {
                        <div class="w-100 my-4">
                          <form [formGroup]="formularioBeneficio"  (keydown.enter)="$event.preventDefault()">
                            @if (!edicaoBeneficioAtiva) {
                              <div class="mb-2">
                                <label class="label" for="campoInputBeneficio">BENEFÍCIO (digite e selecione o benefício)</label>
                                @if (!listaNomesBeneficios) {
                                  <div>
                                    <input type="text" class="form-control float-start me-3 w-70" [(ngModel)]="campoInputBeneficio" [ngModelOptions]="{standalone: true}" (keyup.enter)="pesquisarBeneficio()" placeholder="Digite o nome do benefício" list="listaBeneficios">
                                    <button class="botao-outline" (click)="pesquisarBeneficio()">
                                      <i class="fa fa-search c-primary icone-lupa" aria-hidden="true"></i>
                                    </button>
                                    <br><br>
                                    <p class="legenda">Digite pelo menos 3 caracteres para pesquisar</p>
                                    @if (listaNomesBeneficios === null) {
                                      <p class="legenda">Consultando benefícios
                                        <output class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></output>
                                      </p>
                                    }
                                    @if (listaNomesBeneficios === false) {
                                      <p class="legenda-erro">Nenhum benefício foi encontrado.</p>
                                    }
                                    @if (listaNomesBeneficios === 0) {
                                      <p class="legenda-erro">Digite no mínimo 3 caracteres para a busca.</p>
                                    }
                                  </div>
                                }
                                @if (listaNomesBeneficios && unicaOpcaoBeneficio) {
                                  <div>
                                    <input type="text" class="form-control float-start me-3 w-70" [(ngModel)]="campoInputBeneficio" [ngModelOptions]="{standalone: true}"title="{{campoInputBeneficio}}" readonly="readonly">
                                    <button class="botao-outline" (click)="limparBuscaBeneficio()">Limpar busca</button>
                                  </div>
                                }
                                @if (listaNomesBeneficios && !unicaOpcaoBeneficio) {
                                  <div>
                                    <app-select
                                      [form]="formularioBeneficio"
                                      name="idProduto"
                                      [options]="listaNomesBeneficiosOptions"
                                      defaultDescription="Selecione um benefício"
                                      [ngClass]="'me-3 w-70 float-start'"
                                      (change)="defineValorUnitario($event.target.value.split('@')[1])"
                                      optionValue="value"
                                      optionText="description">
                                    </app-select>
                                    <button class="botao-outline" (click)="limparBuscaBeneficio()">Limpar busca</button>
                                  </div>
                                }
                              </div>
                            }
                            @if (edicaoBeneficioAtiva) {
                              <div class="mb-2">
                                <span class="label">BENEFÍCIO</span>
                                <p class="descricao">{{beneficioSelecionadoEditar.descProduto}}</p>
                              </div>
                            }
                            <div class="w-100 clearfix">
                              <div class="mb-3 w-33 float-start pe-4 mt-4">
                                <label class="label" for="qtdeDiasTrabalhados">DIAS TRABALHADOS</label>
                                <input type="number" id="qtdeDiasTrabalhados" min="0" onkeypress="return event.charCode != 45" class="form-control" formControlName="qtdeDiasTrabalhados" placeholder="Dias Trabalhados">
                              </div>
                              <div class="mb-3 w-33 float-start pe-4 mt-4">
                                <div class="d-flex" >
                                  <label class="label" for="qtdeDias" style="width: 70%;">BENEFÍCIOS POR DIA</label>
                                  <i
                                    class="fa fa-info-circle c-black fa-1x icone-padrao"
                                    aria-hidden="true"
                                    [popover]="popoverBeneficiosPorDia"
                                    popoverTitle="Benefícios por dia"
                                    popoverPlacement="top"
                                    triggers="click"
                                    [outsideClick]="true">
                                  </i>
                                  <ng-template #popoverBeneficiosPorDia>
                                    <span>
                                      Neste campo, você especifica quantos benefícios o usuário recebe diariamente.
                                    </span>
                                  </ng-template>
                                </div>
                                <input type="number" min="0" onkeypress="return event.charCode != 45" class="form-control" formControlName="qtdeDias" placeholder="Benefícios por dia" id="qtdeDias">
                              </div>
                              <div class="mb-3 w-33 float-start mt-4">
                                <label class="label" for="inputValorItemBeneficio">VALOR UNITÁRIO</label>
                                <input type="number" min="0" onkeypress="return event.charCode != 45" class="form-control" formControlName="valorItem" placeholder="Ex: 6,54" id="inputValorItemBeneficio">
                              </div>
                            </div>
                            <div class="w-100 clearfix">
                              @if (edicaoBeneficioAtiva) {
                                <div class="mb-2">
                                  <span class="label">Nº cartão:</span>
                                  @if (beneficioSelecionadoEditar.cartao) {
                                    <p class="descricao">{{beneficioSelecionadoEditar.cartao}}</p>
                                  }
                                  @if (!beneficioSelecionadoEditar.cartao) {
                                    <p class="descricao">Não possui cartão</p>
                                  }
                                </div>
                              }
                            </div>
                            <p class="legenda-erro mt-2 mb-4">{{mensagemErroBeneficio}}</p>
                            <button class="botao-outline me-4 mb-2 px-5" [routerLink]="['/usuario-beneficio']">FECHAR</button>
                            <button class="botao px-5 mb-2" [ngClass]="{'disabled': !formularioBeneficio.valid}" [disabled]="!formularioBeneficio.valid" (click)="salvarBeneficio()">SALVAR</button>
                            @if (edicaoBeneficioAtiva) {
                              <button class="botao-secundario-outline ms-4 px-5" (click)="cancelarEdicao()">CANCELAR EDIÇÃO</button>
                            }
                          </form>
                        </div>
                      }
                      <!-- FOOTER PARA TODAS AS PÁGINAS -->
                      @if (mensagemErroRotaInteligente) {
                        <div class="row my-3">
                          <p class="legenda-erro mensagem-erro">{{mensagemErroRotaInteligente}}</p>
                        </div>
                      }
                      <div class="row border-top pt-4 text-center">
                        <button class="botao-outline me-2 mb-3 px-5 mx-auto" [ngClass]="{'disabled': !idUsuario}"
                        (click)="navegarRotaInteligente()">ROTA INTELIGENTE</button>
                        <button class="botao-outline me-2 mb-3 px-5 mx-auto" [ngClass]="{'disabled': !idUsuario}"
                        (click)="navegarHistoricoCompras()">HISTÓRICO</button>
                        <button class="botao-outline me-2 mb-3 px-5 mx-auto" [ngClass]="{'disabled': !idUsuario}"
                        (click)="gerarRelatorioOpcaoVt()">OPÇÃO DE VT</button>
                      </div>
                    </div>
                  </div>
                  <!-- PARTE DE BENEFÍCIOS (DIV LATERAL) -->
                  @if (abaSelecionada == 3) {
                    <div class="col-12 col-lg-4 mt-4 mt-lg-0">
                      <div class="card">
                        <h1 class="titulo">Benefício</h1>
                        <p class="paragrafo mb-4">Resumo por benefício selecionado</p>
                        @if (beneficios) {
                          <div class="row">
                            @for (beneficio of beneficios; track beneficio) {
                              <div class="col-12 border-top pt-3">
                                <div class="float-end">
                                  <ng-template #myPopoverRPS>
                                    <span class="texto-titulo">
                                      Clique aqui para solicitar
                                    </span>
                                  </ng-template>
                                  <div class="botao-segunda-via" mat-raised-button
                                    matTooltip="Para solicitar a 2ª via o funcionário deverá possuir número de cartão já associado ao cadastro. Poderá ser aplicado também regras de cada operadora."
                                    aria-label="Tooltip que mostra regras para tirar 2º via"
                                    matTooltipPosition="above"
                   [ngClass]="{
                              notallowed: !beneficio.podeAbrirOcorrencia || !('UsuariosDeBeneficioSolicitacao2aVia' | usuarioPermissao:'Imprimir' | async)
                            }">
                                    <a (click)="solicitarSegundaVia(beneficio.idProduto)"
                   [ngClass]="{
                                disabled: !beneficio.podeAbrirOcorrencia || !('UsuariosDeBeneficioSolicitacao2aVia' | usuarioPermissao:'Imprimir' | async)
                              }">
                                      2ª via <i class="fa fa-clone" style="font-size: 13px" aria-hidden="true"></i>
                                    </a>
                                  </div>
                                  <button
                                    class="btn p-0 border-0 bg-transparent"
                                    [ngClass]="{ disabled: !('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Alterar' | async) }"
                                    [disabled]="!('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Alterar' | async)"
                                    (click)="editarBeneficio(beneficio)"
                                    (keydown)="editarBeneficio(beneficio)"
                                    aria-label="Editar benefício">
                                    <i class="fa fa-pencil c-primary col-lg-1" style="cursor: pointer; font-size: 14px;" aria-hidden="true"></i>
                                  </button>
                                  <button
                                    class="btn p-0 border-0 bg-transparent"
                                    [ngClass]="{ disabled: !('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Excluir' | async) }"
                                    [disabled]="!('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Excluir' | async)"
                                    (click)="abrirAlertConfirmacao(beneficio.idEmpresaUsuarioProduto)"
                                    (keydown)="abrirAlertConfirmacao(beneficio.idEmpresaUsuarioProduto)"
                                    aria-label="Excluir benefício">
                                    <i class="fa fa-trash c-primary col-lg-1" style="cursor: pointer; font-size: 14px;" aria-hidden="true"></i>
                                  </button>
                                </div>
                                <span class="label-menor">Cod</span>
                                <p class="descricao">{{beneficio.codVendaProduto}}</p>
                                <span class="label-menor">Descrição do benefício</span>
                                <p class="descricao">{{beneficio.descProduto}}</p>
                                <div class="row">
                                  <div class="col-8">
                                    <span class="label-menor">Cartão</span>
                                    @if (beneficio.cartao) {
                                      <p class="descricao">{{beneficio.cartao}}</p>
                                    }
                                    @if (!beneficio.cartao) {
                                      <p class="descricao">Não possui cartão</p>
                                    }
                                  </div>
                                  <div class="col-4">
                                    <span class="label-menor">Dias</span>
                                    <p class="descricao">{{beneficio.dias}}</p>
                                  </div>
                                  <div class="col-3">
                                    <span class="label-menor">Qtde</span>
                                    <p class="descricao">{{beneficio.qtde}}</p>
                                  </div>
                                  <div class="col-3">
                                    <span class="label-menor">Unit</span>
                                    <p class="descricao">{{beneficio.valorUnitario}}</p>
                                  </div>
                                  <div class="col-6">
                                    <span class="label-menor">Subtotal</span>
                                    <p class="descricao">{{beneficio.valorSubTotal}}</p>
                                  </div>
                                </div>
                              </div>
                            }
                            <div class="w-100 border-top pt-3">
                              <p>Valor total: R$: {{valorTotalBeneficio}}</p>
                            </div>
                          </div>
                        }
                        @if (!beneficios) {
                          <div>
                            <p class="descricao">Este usuário ainda não possui nenhum benefício. <br>Os benefícios serão exibidos aqui.</p>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }

              @if (loadingDados === true) {
                <div class="row">
                  <div class="col-12">
                    <div class="card">
                      <h1 class="titulo">Dados do Usuário</h1>
                      <p class="paragrafo mb-4">Cadastro de usuários que utilizam benefícios na empresa</p>
                      @if (dadosUsuario === undefined || dadosUsuario === false) {
                        <app-api-state
                          [state]="dadosUsuario"
                          loadingText="Consultando dados do usuário ..."
                          errorText="Ocorreu um erro na consulta dos dados do usuário.">
                        </app-api-state>
                      }
                    </div>
                  </div>
                </div>
              }

            </div>

            <!-- ALERT DE SELECIONAR A FOTO -->
            @if (alertIncluirFoto) {
              <div class="body-alert">
                <div class="div-alert text-center">
                  <p class="titulo-alert text-center">Carregar foto</p>
                  <p class="subtitulo-alert text-center">Formato JPG tamanho máximo 10mb</p>
                  <P class="subtitulo-alert text-center">Arraste a imagem para seleciona-lá</P>
                  <div class="d-flex justify-content-center row">
                    <div class="btn btn-mdb-color btn-rounded float-start m-3 col-12">
                      <input type="file" id='selecaoArquivo' (change)="fileChangeEvent($event)" accept="{{listaExtensoes}}">
                      <label for="selecaoArquivo">
                        <div class="texto-upload-foto">Selecionar foto</div>
                      </label>
                    </div>
                  </div>
                  <div class="row align-items-center justify-content-center">
                    <div class="col-lg-5">
                      <image-cropper
                        [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1/ 1"
                        [resizeToWidth]="128" [cropperMinWidth]="128" [roundCropper]="false"
                        [transform]="transform" [alignImage]="'left'" [style.display]="showCropper ? null : 'none'"
                        format="jpg" (imageCropped)="imageCropped($event)"
                        (imageLoaded)="imageLoaded()" (loadImageFailed)="loadImageFailed()">
                      </image-cropper>
                      @if (!showCropper && croppedImage) {
                        <img [src]="croppedImage" alt="Pré-visualização da foto"/>
                      }
                    </div>
                  </div>
                  <div class="row align-items-center justify-content-center">
                    <div class="col-lg-1">
                      <i class="fa fa-picture-o c-primary" aria-hidden="true"></i>
                    </div>
                    <div class="col-lg-4">
                      <input type="range" min="1" max="10" [(ngModel)]="tamanhoFoto" id="myRange" (change)="scaleInOut(tamanhoFoto)">
                    </div>
                    <div class="col-lg-1">
                      <i class="fa fa-picture-o c-primary fa-2x" aria-hidden="true"></i>
                    </div>
                  </div>
                  <hr class="hr mt-2">
                  @if (statusApiFoto === null) {
                    <p class="descricao">Subindo foto no sistema ...</p>
                  }
                  @if (statusApiFoto === true) {
                    <p class="descricao c-primary">Foto Salva ✓.</p>
                  }
                  @if (statusApiFoto === false) {
                    <p class="descricao c-danger">Erro ao subir a foto, selecione outra ou tente novamente.</p>
                  }
                  <hr class="hr mt-2">
                  @if (statusApiFoto !== true) {
                    <div>
                      <button class="botaoLongo my-3 me-3 px-5" [ngClass]="{'disabled': !file}" [disabled]="!file" (click)="enviarFoto()">SALVAR</button>
                      <button type="button" class="botao-outline my-3" (click)="cancelarAlertIncluirFoto()">CANCELAR</button>
                    </div>
                  }
                  @if (statusApiFoto === true) {
                    <button class="botaoLongo" (click)="cancelarAlertIncluirFoto()">FECHAR</button>
                  }
                </div>
              </div>
            }

            <!-- ALERT CONFIRMACAO -->
            <app-confirma-exclusao [confirmaExclusao]="alertConfirmacao" (confirmaExclusaoFechou)="fecharAlertConfirmacao($event)"></app-confirma-exclusao>


            <app-footer></app-footer>
